import Vue from 'vue'
import Router from 'vue-router'

import aluguelEquipamento from './routes/aluguelEquipamento'
import analise from './routes/analise'
import balanco from './routes/balanco'
import gpp from './routes/gpp'
import chamado from './routes/chamado'
import cliente from './routes/cliente'
import cd from './routes/cd'
import comissao from './routes/comissao'
import compras from './routes/compras'
import concreto from './routes/concreto'
import consultaCredito from './routes/consultaCredito'
import contrato from './routes/contrato'
import controleGaiola from './routes/controleGaiola'
import credu from './routes/credu'
import dashboard from './routes/dashboard'
import departamentoPessoal from './routes/departamentoPessoal'
import dp from './routes/dp'
import entrega from './routes/entrega'
import entregaDomicilio from './routes/entregaDomicilio'
import etiqueta from './routes/etiqueta'
import ferramenta from './routes/ferramenta'
import filial from './routes/filial'
import gestaoFrota from './routes/gestaoFrota'
import gestaoRotativos from './routes/gestaoRotativos'
import marketing from './routes/marketing'
import meuUsuario from './routes/meuUsuario'
import normativa from './routes/normativa'
import omnichat from './routes/omniChat'
import liberacao from './routes/liberacao'
import logistica from './routes/logistica'
import pricing from './routes/pricing'
import projeto from './routes/projeto'
import parcelamento from './routes/parcelamento'
import remissao from './routes/remissao'
import rupturas from './routes/rupturas'
import seguro from './routes/seguro'
import servicocredito from './routes/servicocredito'
import sorteio from './routes/sorteio'
import solar from './routes/solar'
import ti from './routes/ti'
// import transferencia from './routes/transferencia'
import unificador from './routes/unificador'
import usuario from './routes/usuario'
import venda from './routes/venda'
import wolihub from './routes/wolihub'
import pedidoCompra from './routes/pedidoCompra'
import gestaoPreCarga from "@/router/routes/gestaoPreCarga";
import controleVisitas from './routes/controleVisitas'
import centralBI from "@/router/routes/centralbi";

Vue.use(Router)

let title = ' | Gestor - Comercial Ivaiporã'

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'Login',
            props: true,
            component: () => import('../Components/Login/Login'),
            meta: {
                title: 'Login' + title
            }
        },
        {
            path: '/login/sair',
            name: 'LoginSair',
            props: true,
            component: () => import('../Components/Login/Sair'),
            meta: {
                title: 'Sair' + title
            }
        },
        {
            path: '/prototipo',
            name: 'Prototipo',
            props: true,
            component: () => import('../Components/Ti/Prototipo'),
            meta: {
                title: 'Protótipo' + title
            }
        },
        aluguelEquipamento,
        analise,
        balanco,
        chamado,
        cd,
        centralBI,
        cliente,
        comissao,
        compras,
        concreto,
        consultaCredito,
        contrato,
        controleGaiola,
        credu,
        dashboard,
        departamentoPessoal,
        dp,
        entrega,
        entregaDomicilio,
        etiqueta,
        ferramenta,
        filial,
        gestaoFrota,
        gestaoRotativos,
        gpp,
        marketing,
        meuUsuario,
        normativa,
        omnichat,
        liberacao,
        logistica,
        parcelamento,
        pricing,
        projeto,
        remissao,
        rupturas,
        seguro,
        servicocredito,
        sorteio,
        solar,
        ti,
        // transferencia,
        unificador,
        usuario,
        venda,
        wolihub,
        pedidoCompra,
        gestaoPreCarga,
        controleVisitas,
        {
            path: '*',
            component: () => import('../Components/Erro/404'),
        }
    ]
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title === title ? title.replace(' | ', '') : to.meta.title

    // PROTEÇÃO CONTRA /login quando logado
    if (to.path === '/login') {
        const usuarioSessaoRaw = localStorage.getItem('comercialivaipora_gestor')

        if (usuarioSessaoRaw) {
            try {
                const sessao = JSON.parse(usuarioSessaoRaw)

                // MUDANÇA: Se tem token OU tem idusuario, considera logado
                if (sessao && (sessao.token || sessao.idusuario)) {
                    // Força o redirecionamento com replace
                    next({ path: '/dashboard', replace: true })
                    return // IMPORTANTE: return após next()
                }
            } catch (error) {
                localStorage.removeItem('comercialivaipora_gestor')
            }
        }

        next()
        return
    }

    if (to.path !== '/' && to.path !== '/prototipo' && to.path !== '/login/sair') {
        let usuarioSessao = localStorage.getItem('comercialivaipora_gestor')

        if (!usuarioSessao) {
            next('/login')
            return
        }

        try {
            usuarioSessao = JSON.parse(usuarioSessao)
        } catch (error) {
            localStorage.removeItem('comercialivaipora_gestor')
            next('/login')
            return
        }

        let usuarioPerm = usuarioSessao.permissao.filter((p) => {
            return p.idpermissao === to.meta.permission
        }).length > 0
        if (usuarioPerm) {
            next()
        } else {
            next({ path: '/' })
        }
    } else {
        next()
    }
})

router.afterEach(() => { })

export default router